export default __webpack_public_path__ + "static/media/8C638F79-674D-416E-823D-4FB39C004F06.8b59448d.jpeg";